import React, { useState } from 'react';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/react-hooks';
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
  Text,
  VStack,
  useToast,
} from '@chakra-ui/react';
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import useUpdateCoalitionsCache from '../../Hooks/useUpdateCoalitionsCache';

const DELETE_COALITION = gql`
mutation deleteCoalition($id: Int!) {
  deleteCoalition(input: {
    id: $id
  }) {
    message
  }
}
`;

export const DeleteCoalitionModal = ({
  isOpen,
  onClose,
}) => {
  const { id, coalitionId } = useParams();
  const updateCache = useUpdateCoalitionsCache(parseInt(id, 10));
  const toast = useToast();
  const history = useHistory();
  const [input, setInput] = useState();


  const [deleteCoalition, { loading: deleteCoalitionLoading }] = useMutation(DELETE_COALITION, {
    variables: {
      id: coalitionId,
    },
    onCompleted: () => {
      updateCache({ id: coalitionId }, 'remove');
      history.push(`/event-manage/${id}/coalitions`);
    },
    onError: (err) => {
      toast({
        title: err.graphQLErrors[0]?.message ?? 'An unknown error occurred. Please try again later.',
        status: 'error',
        isClosable: true,
        position: 'top',
      });
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Coalition</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack>
            <Text>Are you sure you want to delete this coalition? Type DELETE to confirm.</Text>
            <Input value={input} onChange={(e) => setInput(e.target.value)} />
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="red" mr={3} onClick={deleteCoalition} isLoading={deleteCoalitionLoading} disabled={input !== 'DELETE'}>
            Delete Coalition
          </Button>
          <Button colorScheme="gray" variant="outline" mr={3} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
DeleteCoalitionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
